import { Context } from '.'
import Popup from './Popup'

export default class ApplicationRejecteddModal extends Popup {
  constructor(context: Context) {
    super(context)
    this.addCondition(this.checkVisibility)
  }

  checkVisibility = (): boolean => {
    const { session } = this.context

    return (
      Boolean(session?.enabledFeatures.includes('all_in_one_application')) &&
      Boolean(session?.state === 'changes_required')
    )
  }
}
